import { Notice } from './styles';

import Button from '@/components/Button';

type Props = {
  conflict: boolean;
  // The conflict is someone else's draft, not a publish.
  draftConflict?: boolean;
  notice: string | null;
  error: string | null;
  showError: boolean;
  onReload: () => void;
};

const CopyNotices = ({
  conflict,
  draftConflict = false,
  notice,
  error,
  showError,
  onReload,
}: Props) => (
  <>
    {conflict && (
      <Notice tone="red" role="alert" data-testid="copyConflict">
        <span>
          <strong>
            {draftConflict
              ? 'Someone else changed the draft of this message since you opened it.'
              : 'Someone published this message since you opened it.'}
          </strong>{' '}
          Reload to see the latest version. Reloading discards your unsaved
          edits.
        </span>
        <span>
          <Button
            a11yLabel="Reload"
            label="Reload"
            appearance="outline"
            data-testid="copyReloadBtn"
            onClick={onReload}
          />
        </span>
      </Notice>
    )}
    {showError && error && (
      <Notice tone="red" role="alert">
        {error}
      </Notice>
    )}
    {notice && (
      <Notice tone="done" role="status">
        {notice}
      </Notice>
    )}
  </>
);

export default CopyNotices;
